import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { VendorTeamV1 } from '../../../api/api/models/vendor-team-v1'

@Component({
  selector: 'app-chat-window-preview',
  templateUrl: './chat-window-preview.component.html',
  styleUrls: ['./chat-window-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatWindowPreviewComponent {

  @Input() item: VendorTeamV1
  @Input() image: any
  @Input() logo: any
  @Input() hasCallMeEnabled: boolean
  @Input() name: string
}



// WEBPACK FOOTER //
// ./src/app/shared/profile/chat-window-preview/chat-window-preview.component.ts